/**
 * Copied from: https://github.com/temporalio/sdk-typescript/blob/913e67e6381c421c3ed02ee24518adfa1243c84c/packages/workflow/src/workflow.ts#L960C1-L985C2
 *
 * Many environments (like next.js middleware of temporal's workflow) does not allow to use `crypto` module we're using to generation of UUID.
 * Therefore we needed to copy a version that is supported by all environments.
 *
 * Generate an RFC compliant V4 uuid.
 * Uses the workflow's deterministic PRNG making it safe for use within a workflow.
 * This function is cryptographically insecure.
 * See the {@link https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid | stackoverflow discussion}.
 */
export function generateUUID(): string {
    // Create a view backed by a 16-byte buffer
    const view = new DataView(new ArrayBuffer(16));
    // Fill buffer with random values
    view.setUint32(0, (Math.random() * 0x100000000) >>> 0);
    view.setUint32(4, (Math.random() * 0x100000000) >>> 0);
    view.setUint32(8, (Math.random() * 0x100000000) >>> 0);
    view.setUint32(12, (Math.random() * 0x100000000) >>> 0);
    // Patch the 6th byte to reflect a version 4 UUID
    view.setUint8(6, (view.getUint8(6) & 0xf) | 0x40);
    // Patch the 8th byte to reflect a variant 1 UUID (version 4 UUIDs are)
    view.setUint8(8, (view.getUint8(8) & 0x3f) | 0x80);
    // Compile the canonical textual form from the array data
    return [
        numberToHex(view.getUint32(0), 8),
        numberToHex(view.getUint16(4), 4),
        numberToHex(view.getUint16(6), 4),
        numberToHex(view.getUint16(8), 4),
        numberToHex(view.getUint32(10), 8) + numberToHex(view.getUint16(14), 4),
    ].join("-");
}

function numberToHex(num: number, paddingSize: number): string {
    return num.toString(16).padStart(paddingSize, "0");
}
